import { motion, useAnimation, Variants } from 'framer-motion';
import { useEffect, useRef } from 'react';

const variants: Variants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } }
};

export default function Reveal({ children, delay=0.1 }: { children: React.ReactNode; delay?: number }) {
  const controls = useAnimation();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) controls.start('show');
    }, { threshold: 0.15 });
    io.observe(el);
    return () => io.disconnect();
  }, [controls]);

  return (
    <motion.div ref={ref} initial="hidden" animate={controls} variants={variants} transition={{ delay }}>
      {children}
    </motion.div>
  );
}
